import type { CodeScannerState } from '@cli-types/core-engine/utils.js'
import type { TopLevelScanResult } from '@cli-types/next-adapter/init.js'
import { advanceCodeScanner } from '@cli-utils/js-source-scan.js'

export function advanceTopLevelScanner(
  content: string,
  index: number,
  state: CodeScannerState,
  depth: number
): TopLevelScanResult {
  const scanResult = advanceCodeScanner(content, index, state)
  if (scanResult.skip) {
    return { ...scanResult, depth }
  }

  const char = content[index]!

  if (char === '{' || char === '[' || char === '(') {
    return { skip: true, nextIndex: index, depth: depth + 1 }
  }

  if (char === '}' || char === ']' || char === ')') {
    return { skip: true, nextIndex: index, depth: depth - 1 }
  }

  if (depth !== 0) {
    return { skip: true, nextIndex: index, depth }
  }

  return { skip: false, nextIndex: index, depth, char }
}
